<label>{{'OtherProducts.Label.ComponentType' | translate}}</label>
<ng-select [selectOnTab]="false" #select [(ngModel)]="value" [items]="items" bindLabel="name" [clearable]="false"
    [searchable]="false" [ngClass]="{'ng-field-selected': isFilled}" name="component-select">
</ng-select>
